import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Phone, MapPin, Mail } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { waMessage } from "@/components/WhatsAppButton";
import { Logo } from "@/components/Logo";

const Col = ({ title, children }) => (
  <div>
    <h4 className="font-sans text-sm font-semibold uppercase tracking-widest text-white/90">{title}</h4>
    <ul className="mt-4 space-y-2 text-sm text-white/60">{children}</ul>
  </div>
);

const Footer = () => {
  const { settings, social } = useStore();
  const tel = `tel:${(settings.phone || "").replace(/\s/g, "")}`;
  const shopCats = ["Kurtis", "Dresses", "Tops", "Co-ord Sets", "Traditional Wear", "Sandals", "Heels", "Flats", "Casual Footwear"];
  const slug = (s) => s.toLowerCase().replace(/ /g, "-");
  return (
    <footer className="bg-footer-bg text-white" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-16 md:grid-cols-2 lg:grid-cols-5">
        <div className="lg:col-span-1">
          <Logo light size="md" />
          <p className="mt-4 font-script text-2xl text-rose">Style That Speaks</p>
          <p className="mt-3 text-xs uppercase tracking-widest text-white/50">Ladies Fashion • Clothing • Footwear</p>
          <p className="mt-3 text-xs text-white/40">Palanpur, Gujarat, India</p>
        </div>
        <Col title="Quick Links">
          <li><Link to="/" className="hover:text-rose">Home</Link></li>
          <li><Link to="/collections/kurtis" className="hover:text-rose">Clothing</Link></li>
          <li><Link to="/collections/sandals" className="hover:text-rose">Footwear</Link></li>
          <li><Link to="/new-arrivals" className="hover:text-rose">New Arrivals</Link></li>
          <li><Link to="/offers" className="hover:text-rose">Offers</Link></li>
          <li><Link to="/about" className="hover:text-rose">About Us</Link></li>
          <li><Link to="/contact" className="hover:text-rose">Contact</Link></li>
        </Col>
        <Col title="Shop Categories">
          {shopCats.map((c) => <li key={c}><Link to={`/collections/${slug(c)}`} className="hover:text-rose">{c}</Link></li>)}
        </Col>
        <Col title="Customer Service">
          <li><Link to="/contact" className="hover:text-rose">Contact Us</Link></li>
          <li><Link to="/policy/shipping-policy" className="hover:text-rose">Shipping Policy</Link></li>
          <li><Link to="/policy/return-exchange" className="hover:text-rose">Return & Exchange</Link></li>
          <li><Link to="/policy/privacy-policy" className="hover:text-rose">Privacy Policy</Link></li>
          <li><Link to="/policy/terms-conditions" className="hover:text-rose">Terms & Conditions</Link></li>
          <li><Link to="/policy/refund-policy" className="hover:text-rose">Refund Policy</Link></li>
          <li><Link to="/policy/faq" className="hover:text-rose">FAQ</Link></li>
        </Col>
        <Col title="Contact">
          <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-rose" />{settings.business_name}, {settings.location}</li>
          <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-rose" /><a href={tel} className="hover:text-rose" data-testid="footer-phone">{settings.phone}</a></li>
          {settings.email && <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-rose" /><a href={`mailto:${settings.email}`} className="hover:text-rose">{settings.email}</a></li>}
          <li className="flex gap-3 pt-3">
            <a href={social.instagram || "https://www.instagram.com/uniqueclothespalnpur/?hl=en"} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="grid h-9 w-9 place-items-center rounded-full border border-white/20 hover:border-rose hover:text-rose" data-testid="footer-instagram"><Instagram className="h-4 w-4" /></a>
            {social.facebook && <a href={social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="grid h-9 w-9 place-items-center rounded-full border border-white/20 hover:border-rose hover:text-rose"><Facebook className="h-4 w-4" /></a>}
            {social.youtube && <a href={social.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="grid h-9 w-9 place-items-center rounded-full border border-white/20 hover:border-rose hover:text-rose"><Youtube className="h-4 w-4" /></a>}
            <a href={waMessage(settings)} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="grid h-9 w-9 place-items-center rounded-full border border-white/20 hover:border-rose hover:text-rose" data-testid="footer-whatsapp">
              <svg viewBox="0 0 32 32" className="h-4 w-4 fill-current"><path d="M16 3C9 3 3.5 8.5 3.5 15.5c0 2.3.6 4.4 1.7 6.3L3 29l7.4-2.1c1.8 1 3.9 1.5 6 1.5 7 0 12.5-5.5 12.5-12.5S23 3 16 3z"/></svg>
            </a>
          </li>
        </Col>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-6 py-5 text-xs text-white/40 md:flex-row">
          <span>© 2026 ANUSWA by Unique Cloth. All Rights Reserved.</span>
          <span>Made with ♥ for Fashion Lovers</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
